import * as React from 'react';
import { type ReactNode, useEffect, useState } from 'react';
import { sample } from 'lodash';
import styled from 'styled-components';

import { SEO } from '@/components/global/SEO';
import Page from '@/components/v2/Page';
import { V1PageWrapper } from '@/components/v2/Page/V1PageWrapper';
import { styles } from '@/components/v2/UtilityCss/Heading';
import { styles as textStyles } from '@/components/v2/UtilityCss/Text';

import { LinkWithQuery } from '../components/global/LinkWithQuery';
import { ReactComponent as JengaIllustration } from '../images/illustrations/illustration-404-jenga.svg';
import { ReactComponent as StacksIllustration } from '../images/illustrations/illustration-404-stacks.svg';

const Wrapper = styled.div`
  padding: 0 40px 0 40px;
  margin-bottom: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
`;

const Header = styled.div`
  max-width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    /* position: relative; */
    text-align: center;
    margin-bottom: 15px;
  }

  p {
    margin: auto;
    text-align: center;
  }
`;

const IllustrationWrapper = styled.div`
  max-width: 600px;
  width: 100%;
  margin-bottom: 40px;

  svg {
    width: 100%;
  }
`;

interface Illustration {
  heading: string;
  image: ReactNode;
  subheading: string;
}

const MISSING_ILLUSTRATIONS: Illustration[] = [
  {
    image: <JengaIllustration />,
    heading: 'Oops, we broke the modern data stack!',
    subheading:
      "Just playing. You've stumbled upon a broken link or missing page."
  },
  {
    image: <StacksIllustration />,
    heading: "Something isn't stacking up.",
    subheading:
      "Whatever it is, it must be delicious! You've stumbled upon a broken link or missing page."
  }
];

const MissingPage: React.ComponentType = React.memo(() => {
  const [chosenIllustration, setChosenIllustration] = useState<
    Illustration | undefined
  >(undefined);

  useEffect(() => {
    setChosenIllustration(sample(MISSING_ILLUSTRATIONS));
  }, []);

  return (
    <Page
      seo={
        <SEO
          description="You've stumbled upon a broken link or missing page."
          title="Missing page"
          url="/"
        />
      }>
      <V1PageWrapper>
        <Wrapper>
          {chosenIllustration && (
            <>
              <IllustrationWrapper>
                {chosenIllustration.image}
              </IllustrationWrapper>
              <Header>
                <h1 className={styles.h1}>{chosenIllustration.heading}</h1>
                <p className={textStyles.l}>
                  {chosenIllustration.subheading}{' '}
                  <LinkWithQuery to="/">Go home</LinkWithQuery>
                </p>
              </Header>
            </>
          )}
        </Wrapper>
      </V1PageWrapper>
    </Page>
  );
});

export default MissingPage;
